import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-white border-t-2 border-gray-200 mt-16">
      <div className="max-w-5xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row justify-between gap-6">
        <div>
          <p className="font-heading text-xl font-bold text-[#1A1A1A]">Enkla Manualer</p>
          <p className="text-base text-[#4A4A4A] mt-2 max-w-md">
            Tydliga och pedagogiska manualer för iPhone, iPad, MacBook och Windows 11 – gjorda för alla.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <Link to="/om-oss" data-testid="footer-about" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Om oss &amp; Vår vision
          </Link>
          <Link to="/hjalp" data-testid="footer-help" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Hjälp och vanliga frågor
          </Link>
          <Link to="/kontakt" data-testid="footer-contact" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Kontakta oss
          </Link>
          <Link to="/batteribyte" data-testid="footer-battery" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Batteribyte på datorn
          </Link>
          <Link to="/enhetsbyte" data-testid="footer-mobile" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Enkelt enhetsbyte
          </Link>
          <Link to="/digitala-las" data-testid="footer-lock" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Digitalt lås
          </Link>
          <Link to="/uppgradering" data-testid="footer-upgrade" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Snabbare dator &amp; mer lagring
          </Link>
          <Link to="/tillganglighet" data-testid="footer-access" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Anpassad tillgänglighet
          </Link>
          <Link to="/boka" data-testid="footer-booking" className="text-lg font-semibold text-[#0056D2] hover:underline">
            Boka en tid
          </Link>
          <a href="mailto:support@enklamanualer.se" data-testid="footer-email" className="text-lg font-semibold text-[#0056D2] hover:underline">
            support@enklamanualer.se
          </a>
          <Link to="/admin" data-testid="footer-admin" className="text-base text-[#4A4A4A] hover:underline mt-2">
            Administration
          </Link>
        </div>
      </div>
    </footer>
  );
};
